import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import "./style.scss";

const AccordionWrapper = ({
  heading,
  headingOpen,
  status = { icon: "", text: "" },
  open = false,
  children
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const accordionWrapperTitleClassList = classNames("accordion-wrapper-title", {
    open: isOpen
  });

  const accordionContentClassList = classNames("accordion-wrapper-content", {
    open: isOpen
  });

  const openIconClassList = classNames("add", {
    open: isOpen
  });

  return (
    <div className="accordion-wrapper">
      <div
        className={accordionWrapperTitleClassList}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="title-group">
          {!isOpen && <Heading {...heading} />}

          {isOpen && <Heading {...(headingOpen ? headingOpen : heading)} />}

          <div className="icon-group">
            <div className="status-indication">
              {status.icon?.svg && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: status.icon.svg
                  }}
                ></span>
              )}
              {status.text && <span>{status.text}</span>}
            </div>
          </div>
        </div>

        <div className="icon-group">
          <span className={openIconClassList}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
          </span>
        </div>
      </div>
      <div className={accordionContentClassList}>{children}</div>
    </div>
  );
};

AccordionWrapper.propTypes = {
  heading: PropTypes.object,
  headingOpen: PropTypes.object,
  status: PropTypes.shape({
    icon: PropTypes.string,
    text: PropTypes.string
  }),
  open: PropTypes.bool
};

export default AccordionWrapper;
